function initMobileSwipeGallery(root) {
  if (!root) return;
 
  const track = root.querySelector('[data-mobile-swipe-track]');
  const dotsContainer = root.querySelector('[data-mobile-swipe-dots]');
 
  if (!track) return;
 
  const slides = Array.from(track.children);
  if (!slides.length) return;
 
  if (dotsContainer) {
    dotsContainer.innerHTML = '';
    slides.forEach((_, index) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'mobile-swipe-gallery__dot';
      dot.setAttribute('aria-label', 'Go to image ' + (index + 1));
      if (index === 0) dot.setAttribute('aria-current', 'true');
      // Clicking a dot is the only place we intentionally move the scroll,
      // the free swipe itself is never intercepted.
      dot.addEventListener('click', () => {
        slides[index].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      });
      dotsContainer.appendChild(dot);
    });
  }
 
  function updateActiveDot() {
    if (!dotsContainer) return;
    const trackRect = track.getBoundingClientRect();
    const centerX = trackRect.left + trackRect.width / 2;
 
    let closestIndex = 0;
    let closestDistance = Infinity;
 
    slides.forEach((slide, index) => {
      const rect = slide.getBoundingClientRect();
      const slideCenter = rect.left + rect.width / 2;
      const distance = Math.abs(slideCenter - centerX);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });
 
    const dots = dotsContainer.querySelectorAll('.mobile-swipe-gallery__dot');
    dots.forEach((dot, index) => {
      if (index === closestIndex) {
        dot.setAttribute('aria-current', 'true');
      } else {
        dot.removeAttribute('aria-current');
      }
    });
  }
 
  let scrollTimeout;
  track.addEventListener('scroll', () => {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(updateActiveDot, 80);
  });
}
 
function initAllMobileSwipeGalleries() {
  document.querySelectorAll('[data-mobile-swipe-gallery]').forEach(initMobileSwipeGallery);
}
 
document.addEventListener('DOMContentLoaded', initAllMobileSwipeGalleries);
document.addEventListener('shopify:section:load', (event) => {
  const root = event.target.querySelector('[data-mobile-swipe-gallery]');
  if (root) initMobileSwipeGallery(root);
});